import { useNavState } from '@/providers/NavStateProvider';
import { useEffect } from 'react';
import { useIntercomGuide } from '@/hooks/useIntercomGuide';
import { ScrollTop } from '@/components/element/ScrollTop';
import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { FilterModal } from '@/features/w/[identifier]/dashboard/pl/{components}/FilterModal';
import { SearchConditionTags } from '@/features/w/[identifier]/dashboard/pl/{components}/SearchConditionTags';
import { MonthlyAnalysis } from '@/features/w/[identifier]/dashboard/pl/{components}/MonthlyAnalysis';

export const PlDashboard = () => {
  const { setTitle, setBreadcrumbs } = useNavState();

  useEffect(() => setTitle('売上-費用ボード'), []);
  useEffect(() => setBreadcrumbs([]), []);

  useIntercomGuide();

  return (
    <WorkspaceLayout>
      <ScrollTop />

      <div className="container-fluid py-4">
        <div className="d-flex align-items-center mb-4">
          <button className="btn btn-icon-only btn-dark mx-2" data-bs-toggle="modal" data-bs-target="#modal-filter">
            <i className="fas fa-filter"></i>
          </button>
        </div>

        <SearchConditionTags />

        <FilterModal />

        <MonthlyAnalysis />
      </div>
    </WorkspaceLayout>
  );
};
